// Paletas DARK e LIGHT — identidade visual azul.
// Primária: blue-500 (#3B82F6) em dark, blue-600 (#2563EB) em light
// (blue-600 dá AAA em texto sobre branco; blue-500 sobre escuro).
// Status "blue" deslocado pra ciano pra não colidir com o accent primário.

export const DARK = {
  bg: "#0F1923",
  bgCard: "#162332",
  bgCardHover: "#1C2E42",
  sidebar: "#0B1219",
  accent: "#3B82F6",
  accentLight: "#60A5FA",
  accentDim: "rgba(59,130,246,0.15)",
  green: "#34D399",
  greenDim: "rgba(52,211,153,0.12)",
  red: "#F87171",
  redDim: "rgba(248,113,113,0.12)",
  blue: "#22D3EE",
  blueDim: "rgba(34,211,238,0.12)",
  purple: "#A78BFA",
  purpleDim: "rgba(167,139,250,0.12)",
  text: "#E8EDF2",
  textMuted: "#7A8FA3",
  textDim: "#4A5D72",
  border: "#1E3348",
  inputBg: "#162332",
  avatarText: "#0B1219",
  barInactive: "linear-gradient(180deg, #1E3348, #1C2E42)",
};

export const LIGHT = {
  bg: "#F4F6F9",
  bgCard: "#FFFFFF",
  bgCardHover: "#F0F2F5",
  sidebar: "#FFFFFF",
  accent: "#2563EB",
  accentLight: "#3B82F6",
  accentDim: "rgba(37,99,235,0.10)",
  green: "#16A34A",
  greenDim: "rgba(22,163,74,0.08)",
  red: "#DC2626",
  redDim: "rgba(220,38,38,0.08)",
  blue: "#0891B2",
  blueDim: "rgba(8,145,178,0.08)",
  purple: "#7C3AED",
  purpleDim: "rgba(124,58,237,0.08)",
  text: "#1A2332",
  textMuted: "#5F7083",
  textDim: "#9CA8B7",
  border: "#E2E7ED",
  inputBg: "#F4F6F9",
  avatarText: "#FFFFFF",
  barInactive: "linear-gradient(180deg, #E2E7ED, #F0F2F5)",
};

export const MONTHS_PT = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
export const MONTHS_PT_LONG = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
export const DAYS_PT = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
export const DAYS_PT_LONG = ["domingo","segunda","terça","quarta","quinta","sexta","sábado"];
